if (!customElements.get('tab-group')) {
  customElements.define(
    'tab-group',
    class Tabs extends HTMLElement {
      constructor() {
        super();
        this.tabContents = this.querySelectorAll('.tab-content');
        this.tabLinks = this.querySelectorAll('button.tab-button');
        this.tabLinks.forEach((button) =>
          button.addEventListener('click', this.onButtonClick.bind(this))
        );
      }

      onButtonClick(event) {
        console.log(event.target)
        console.log(this.tabContents)
        let targetContent = event.target.getAttribute('data-tab');
        this.tabLinks.forEach((link) => {
          if (link.getAttribute('data-tab') !== targetContent) {
            link.classList.remove('button--primary');
            link.classList.add('button--secondary');
          }
          else {
            link.classList.add('button--primary');
            link.classList.remove('button--secondary');
          }
        });
        this.tabContents.forEach((content) => {
          if (content.getAttribute('data-tab') !== targetContent) {
            content.setAttribute('active', false);
          }
          else {
            content.setAttribute('active', true);
          }
        });
      }
      
    }
  )
}
